import { useCertificationLogoStyles } from './useCertificationLogoStyles';
import { SizingOptions } from '../Awards/types';
import { envs } from '../../../../envs';
import { Tooltip } from '@mui/material';

interface CertificationLogoProps {
  certificationValue: string;
  size?: SizingOptions;
}

const CertificationLogo = ({
  certificationValue,
  size = SizingOptions.SMALL
}: CertificationLogoProps) => {
  const { classes } = useCertificationLogoStyles({ size });
  return (
    <Tooltip title={certificationValue}>
      <span className={classes.container}>
        <img
          src={
            envs.REACT_APP_COVALO_STATIC_CONTENT +
            '/certifications/' +
            certificationValue
          }
          className={classes.image}
          alt={certificationValue + ' certification image'}
        />
      </span>
    </Tooltip>
  );
};

export default CertificationLogo;
